module.exports = __webpack_public_path__ + "img/cancel_FILL1_wght400_GRAD0_opsz48 1.f44f97c7.svg";